const invalidNumericSymbols = ['e', 'E'];
const invalidSignSymbols = ['-', '+'];

/**
 * Function that can be attached to a numeric input field in order to block the non-numeric symbols like 'e'
 */
export function blockInvalidNumericSymbol(event: KeyboardEvent, blockSignSymbols = false): void {
  const invalidSymbols = blockSignSymbols ? [...invalidNumericSymbols, ...invalidSignSymbols] : invalidNumericSymbols;

  if (invalidSymbols.includes(event.key)) {
    event.preventDefault();
  }
}
